import type { SiteProviderRole } from "./api"

export function labelForProvider(provider: string): string {
  switch (provider) {
    case "google":
      return "Google"
    case "meta":
      return "Meta"
    default:
      return provider
  }
}

export function formatAccountType(value: string): string {
  switch (value) {
    case "google_ads_customer":
      return "Google Ads"
    case "ga4_account":
      return "GA4 account"
    case "ga4_property":
      return "GA4 property"
    case "search_console_site":
      return "Search Console"
    case "meta_ad_account":
      return "Meta ad account"
    default:
      return value
  }
}

export function providerRoleLabel(role: SiteProviderRole): string {
  switch (role) {
    case "ads":
      return "Ads"
    case "analytics":
      return "Analytics"
    case "search_console":
      return "Search Console"
  }
}
